import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import _get from 'lodash/get';
import { RESOLUTION_IMAGE_UPLOAD } from '@shared/const/profile.const';

@Component({
  selector: 'app-web-cam-profile-dialog',
  templateUrl: './web-cam-profile-dialog.component.html',
  styleUrls: ['./web-cam-profile-dialog.component.scss'],
})
export class WebCamProfileDialogComponent implements OnInit {
  public webcamImage: any;
  public showCam = false;
  public height: number;
  public width: number;
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<WebCamProfileDialogComponent>,
    public breakpointObserver: BreakpointObserver,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit(): void {
    this.deviceDetector();
  }

  public deviceDetector() {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.width = 300;
          this.height = 390;
        } else if (result.breakpoints[Breakpoints.Small]) {
          this.width = 350;
          this.height = 390;
        } else if (result.breakpoints[Breakpoints.Medium]) {
          this.width = 430;
          this.height = 390;
        } else if (result.breakpoints[Breakpoints.Large]) {
          this.width = 500;
          this.height = 390;
        } else {
          this.width = 500;
          this.height = 390;
        }
      });
  }

  public showCamera() {
    this.showCam = true;
    this.webcamImage = false;
  }

  public cancelTakePhoto() {
    this.webcamImage = false;
    this.showCam = false;
  }

  public takeOtherPhoto() {
    this.webcamImage = false;
    this.showCam = true;
  }

  public triggerSnapshot(): void {
    this.trigger.next(null);
  }

  public savePhoto() {
    if (this.webcamImage) {
      const imageAsDataUrl = _get(this.webcamImage, '_imageAsDataUrl', '');
      const mimeType = _get(this.webcamImage, '_mimeType', '');
      const img = new Image();
      img.src = imageAsDataUrl;
      const canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      canvas.width = RESOLUTION_IMAGE_UPLOAD;
      canvas.height = RESOLUTION_IMAGE_UPLOAD;
      ctx = canvas.getContext('2d');
      ctx.drawImage(
        img,
        0,
        0,
        RESOLUTION_IMAGE_UPLOAD,
        RESOLUTION_IMAGE_UPLOAD
      );
      const dataurl = canvas.toDataURL(mimeType);
      this.webcamImage = { imageAsDataUrl: dataurl };
    }
    this.dialogRef.close(this.webcamImage);
  }

  public closeModal() {
    this.webcamImage = false;
    this.dialogRef.close(false);
  }

  /* public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
  } */

  public openSelectImage() {
    document.getElementById('inputSelectImage').click();
  }

  public showPreview(event: Event) {
    const reader = new FileReader();
    const file = event.target['files'][0];
    reader.onload = (e: any) => {
      const img = document.createElement('img');
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        canvas.width = RESOLUTION_IMAGE_UPLOAD;
        canvas.height = RESOLUTION_IMAGE_UPLOAD;
        ctx = canvas.getContext('2d');
        ctx.drawImage(
          img,
          0,
          0,
          RESOLUTION_IMAGE_UPLOAD,
          RESOLUTION_IMAGE_UPLOAD
        );
        const dataurl = canvas.toDataURL(file.type);
        this.webcamImage = { imageAsDataUrl: dataurl };
        this.dialogRef.close(this.webcamImage);
      };
    };
    reader.readAsDataURL(file);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
}
